module.exports = __webpack_public_path__ + "static/media/Icon_delete_solid.11728448.svg";